import React from 'react';

import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';

import PopupFullPage from './PopupFullPage';
import PopupOutline from './PopupOutline';

const PopupResponsive = ({shouldShowFullPage, ...rest}) => {
    const isMobile = useIsMobileLayout();
    const showFullPage = typeof shouldShowFullPage === 'boolean' ? shouldShowFullPage : isMobile;

    if (showFullPage) {
        return <PopupFullPage disablePageScrolling {...rest} />;
    } else {
        return <PopupOutline isBlockerOverlay {...rest} />;
    }
};

export default PopupResponsive;
